import { render } from "./CourseDetail.vue?vue&type=template&id=ad834094&scoped=true"
import script from "./CourseDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseDetail.vue?vue&type=script&setup=true&lang=js"

import "./CourseDetail.vue?vue&type=style&index=0&id=ad834094&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad834094"],['__file',"src/views/course/CourseDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ad834094"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ad834094', __exports__)) {
    api.reload('ad834094', __exports__)
  }
  
  module.hot.accept("./CourseDetail.vue?vue&type=template&id=ad834094&scoped=true", () => {
    api.rerender('ad834094', render)
  })

}


export default __exports__